<template>
  <div>
    <CRUDCriteria :showReset="true" :showSearch="false" :showAdditionalActions="true">
      <template v-slot:criteriaRows>
        <div class="mt-0 ml-6 mr-6 mb-0 pa-0">
          <v-row class="ma-n4">
            <v-col cols="3" class="pt-0 pb-0">
              <CommonDropDowns :isItTaxYear=true @change="dataFromCommonDropDowns"
              :criteriaState="criteriaState"/>
            </v-col>
            <v-col cols="3" class="pt-0 pb-0">
              <v-text-field class="input-text-size" label="Owner Name - Exact Search"
              v-uppercase=globalSettingItem.conEverythingToCaps
              v-model="criteriaState.ownerName" @input="searchByTimeOut('ownerName')" />
            </v-col>
            <v-col cols="3" class="pt-0 pb-0">
              <v-text-field class="input-text-size" label="Owner Name - Wildcard Search"
              v-uppercase=globalSettingItem.conEverythingToCaps
              v-model="criteriaState.ownerNameWildCard"
              @input="searchByTimeOut('ownerNameWildCard')" />
            </v-col>
            <v-col cols="3" class="pt-0 pb-0">
              <v-text-field class="input-text-size" label="Number"
              v-model="criteriaState.ownerNumber" @input="searchByTimeOut" type="number" />
            </v-col>
            <v-col cols="3" class="pt-0 pb-0  mt-n6">
              <v-text-field class="input-text-size" label="Address - WildCard"
              v-uppercase=globalSettingItem.conEverythingToCaps
              v-model="criteriaState.comOwnerAddress" @input="searchByTimeOut('comOwnerAddress')" />
            </v-col>
            <v-col cols="3" class="pt-0 pb-0  mt-n6">
              <v-text-field class="input-text-size" label="In Care of Name"
              v-uppercase=globalSettingItem.conEverythingToCaps
              v-model="criteriaState.inCareOf" @input="searchByTimeOut" />
            </v-col>
            <v-col cols='2' class="pt-0 pb-0 mt-n6">
              <ClarionDateControl class="input-text-size" :isToggle="false" @input="penaltyCaclFunc"
                :penalty-change-day="Number(taxSettingItem.penaltyDate) || null"
                v-model="criteriaState.penaltyDateValue" label="Penalty Date" />
            </v-col>
            <v-col cols='2' class="pt-0 pb-0 mt-n6">
              <v-checkbox class="input-text-size"
                @change="searchByCriteria"
                v-model="criteriaState.unpaids" :label="`Unpaids Only`" />
              </v-col>
            <!-- <v-col cols='2' class="pt-0 pb-0 mt-n6">
            <v-switch
              :label="getSearchTypeLabel"
              color="primary" v-model="criteriaState.searchType"
              @change="searchByTimeOut" />
            </v-col> -->
          </v-row>
        </div>
      </template>
      <template v-slot:additionalActions>
        <v-col cols="2" class="pt-0 mt-n5">
            <v-switch
            :label="!togglePrintOrEmail ? 'Print' : 'Email'"
            v-model="togglePrintOrEmail"
            color="primary"
            dense
            @change="val => onChangeTogglePrintOrEmail(val)"
            hide-details>
            </v-switch>
        </v-col>
        <v-col cols="2" class="pt-0">
          <v-btn class="input-text-size white-space-pre-line"
           text color="blue darken-1" @click="handlePickList">
           <span>{{pickListProfileName}}</span>
          </v-btn>
        </v-col>
      </template>
    </CRUDCriteria>
    <ProtestAndPickListTabs :baseCrudKey="baseCrudKeyPickList"
    @refetchTaxInquiryData="refetchTaxInquiryData" />
  </div>
</template>

<script>
import {
  mapMutations, mapGetters, mapState,
} from 'vuex';
import ClarionDateControl from '@/components/common/ClarionDateControl.vue';
import CRUDCriteria from '../../../common/base/crud-2.0/CRUDCriteria.vue';
import ProtestAndPickListTabs from '../Common/ProtestAndPickListTabs.vue';
import CommonDropDowns from '../../common-utils/CommonDropDowns.mixin.vue';
import { toShortDate } from '../../../../util/shared/tmc-global';
import { makeCriteriaStateNullIfEmptyString, penaltyCaclCrudListCommonFunc } from '../../common-utils/CommonTaxFunctionalities';
import { SEARCH_DEBOUNCE_TIMER } from '../../common-utils/constants';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';
import { getWorkstationNumber } from '../../../../util/workstation-util';
import '../../../../assets/style.css';

export default {
  mixins: [GlobalToCaps],
  data() {
    return {
      pickListProfileName: 'Pick List',
      baseCrudKeyPickList: 'ProtestAndPickListTabs',
      delayTimerId: null,
      workstation: getWorkstationNumber(),
    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
    feeListBasedInIds: {
      type: Array,
      default: () => ([]),
    },
  },
  components: {
    ClarionDateControl,
    CRUDCriteria,
    ProtestAndPickListTabs,
    CommonDropDowns,
  },
  created() {
    this.criteriaState.penaltyDateValue = this.criteriaState.penaltyDateValue || toShortDate();
    this.getPickListProfileName();
  },
  mounted() {
    this.getPickListProfileName();
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'items']),
    ...mapGetters('user', [
      'getSettings',
    ]),
    ...mapGetters([
      'todaysDate',
    ]),
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      togglePrintOrEmail: (state) => state.tax.taxInquires.togglePrintOrEmail,
      pickListVisible: (state) => state.base.crud.isVisible.ProtestAndPickListTabs,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    getSearchTypeLabel() {
      return (this.criteriaState || {}).searchType ? 'Atlas Search' : 'Regular Search';
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setIsVisible',
      'setCriteria',
      'setItems',
      'setItem',
      'setPaginationItems',
      'setHighlightedId',
    ]),
    ...mapMutations('tax/taxInquires', [
      'setTogglePrintOrEmail',
    ]),
    searchByTimeOut(whichCriteria) {
      clearTimeout(this.delayTimerId);
      this.delayTimerId = setTimeout(() => {
        // Skip firing an expensive text search on 1-2 chars (avoids full-collection scans).
        // ownerName is an anchored prefix match, so it's cheap at any length and exempt here.
        const textFields = ['ownerNameWildCard', 'comOwnerAddress', 'inCareOf'];
        if (textFields.includes(whichCriteria)) {
          const val = (this.criteriaState[whichCriteria] || '').trim();
          if (val.length > 0 && val.length < 3) return;
        }
        this.searchByCriteria(whichCriteria);
      }, SEARCH_DEBOUNCE_TIMER);
    },
    penaltyCaclFunc(val) {
      clearTimeout(this.delayTimerId);
      this.delayTimerId = setTimeout(() => {
        this.setHighlightedId([this.baseCrudKey, '']);
        const itemData = this.items(this.baseCrudKey);
        const itemFeeData = this.feeListBasedInIds;
        const returnData = penaltyCaclCrudListCommonFunc(
          val, itemData, this.taxSettingItem, itemFeeData,
        );
        this.setItems(this.baseCrudKey, returnData);
      }, SEARCH_DEBOUNCE_TIMER);
    },
    handlePickList() {
      const pickListFilterItem = {
        taxYear: 0,
        statusCode: null,
        mtgCode: null,
        profileName: '',
      };
      this.setCriteria(['pickListCriteria', pickListFilterItem]);
      this.setItem(['pickListMakePaymentDate', { curPenaltyDate: this.criteriaState.penaltyDateValue }]);
      // this will make the pagination to default
      const paginationItem = {
        itemsperpage: this.getSettings.itemsperpage,
        serverItemsLength: this.getSettings.serverItemsLength,
        footerProps: this.getSettings.footerProps,
      };
      this.setPaginationItems(['pickListTable', paginationItem]);
      this.setPaginationItems(['ProtestTaxPaymentsList', paginationItem]);
      this.$emit('setDefaultSelectedItems');
      this.setIsVisible([this.baseCrudKeyPickList, true]);
    },
    dataFromCommonDropDowns(val, whichField) {
      this.criteriaState[whichField] = val;
      this.searchByCriteria();
    },
    refetchTaxInquiryData() {
      this.$emit('loadCRUDList');
    },
    searchByCriteria(whichCriteria) {
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      // this is to get to 1st pagination, not a best solution because pagination number will be
      // present after the below condition is applied
      if (whichCriteria === 'ownerName' || whichCriteria === 'ownerNameWildCard') {
        returnCriteria.limit = 100;
        returnCriteria.skip = 0;
      }
      const sortByAllTaxYear = [{ column: 'taxYear', direction: 'desc' }, { column: 'taxId', direction: 'asc' }];
      const sortByName = [{ column: 'name1', direction: 'asc' }];
      const sortByAddress = [{ column: 'comOwnerAddress', direction: 'asc' }];

      if (whichCriteria === 'comOwnerAddress') {
        returnCriteria.sortBy = sortByAddress;
      } else if (!returnCriteria.taxYear) {
        returnCriteria.sortBy = sortByAllTaxYear;
      } else {
        returnCriteria.sortBy = sortByName;
      }
      this.criteriaState = { ...returnCriteria };
      this.$emit('loadCRUDList');
    },
    onChangeTogglePrintOrEmail(val) {
      let isItNull = false;
      if (val) isItNull = val;
      this.setTogglePrintOrEmail({ res: isItNull });
    },
    getPickListProfileName() {
      this.pickListProfileName = `Pick List \n ${localStorage.getItem('pick-list-profile-name') || ''}`;
    },
  },
  watch: {
    pickListVisible() {
      this.getPickListProfileName();
    },
  },
};
</script>
